<template>
  <div class="chikusan-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/lD0rU5FN4S0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="chikusan">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/chikusan/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/chikusan/jumbotron_under.jpg" alt="" class="under_display">
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/chikusan/catch.png" alt="戦略を立てて、人気食材をもり立てる。知力で勝負しています。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="chikusan" message="頭をひねって、<br>日々創意工夫することが好きな人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="50" />
          <div class="details">
            <p>
            牛肉・豚肉・鶏肉や、ハム・ソーセージ・ベーコン…。畜産部は、小さなお子さんにも、20代の女性にも、世代を問わず人気の食材を手がける部門です。
            </p>
            <p>
            たとえば、ずっしりとした豚肉の塊を専用の機器で薄切りする。お年を召したお客様のオーダーを受けて、牛のヒレ肉を食べやすい大きさにカットする、など。作業場で過ごす時間と、売場でお客様と対話する時間は1対1くらいです。
            </p>
            <p>
            作業の多くはメンバーに指示を出して進めます。さらに販売促進の計画、仕入れ、売場づくり、接客対応。自分のアイデアでどんどん変えていけることは、畜産部の大きな特徴です。販促のために、専門外の野菜・魚・調味料などの知識も学びます。頭をひねって、積極的にチャレンジしたい方におすすめします。</p>
          </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Chikusan',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.chikusan {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transform: translateX(-40px);
  max-width: 1300px;
  width: 100%;
  left: 0;
  margin: auto;
  right: 0;
  @media print, screen and (max-width: 960px) {
    width: 50%;
    right: 0;
    left: unset;
    transform: translateX(-5px);
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
